// @flow
import React from 'react';
import { Grid, GridColumn, GridRow } from 'semantic-ui-react';
import Card from '../Card';
import * as css from './WarningCard.module.css';

type PropType = {
  className: String,
  title?: String,
  text?: String,
  errorCode?: string,
};

const WarningCard = ({ className, title, text, errorCode }: PropType) => {
  const formatText = (text) => {
    return text
      ? text.split('\\n').map((item) => {
        return (
            <>
              {item} <br />
            </>
        );
      })
      : '';
  };
  return (
    <Card isComviq={true} className={`${css.card} ${className}`}>
      <Grid>
        <GridRow className={`${css.noPaddingBottom}`} columns={2} verticalAlign={'top'}>
          <GridColumn width={1}>
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.8063 37.5511L22.3212 3.05509C22.0499 2.60916 21.5468 2.33331 20.9999 2.33331C20.4508 2.33331 19.9476 2.60916 19.6785 3.05509L0.19556 37.5511C-0.0691426 37.9887 -0.0647673 38.528 0.206498 38.9615C0.479951 39.3991 0.976541 39.6666 1.5147 39.6666H40.485C41.021 39.6666 41.5219 39.3991 41.7932 38.9615C42.0645 38.528 42.0689 37.9887 41.8063 37.5511ZM23.1876 35.5184H18.8124V31.3702H23.1876V35.5184ZM23.1876 28.2595H18.8124V14.778H23.1876V28.2595Z"
                fill="#E95D0F"
              />
              <mask id="mask0" maskUnits="userSpaceOnUse" x="0" y="2" width="42" height="38">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M41.8063 37.5511L22.3212 3.05509C22.0499 2.60916 21.5468 2.33331 20.9999 2.33331C20.4508 2.33331 19.9476 2.60916 19.6785 3.05509L0.19556 37.5511C-0.0691426 37.9887 -0.0647673 38.528 0.206498 38.9615C0.479951 39.3991 0.976541 39.6666 1.5147 39.6666H40.485C41.021 39.6666 41.5219 39.3991 41.7932 38.9615C42.0645 38.528 42.0689 37.9887 41.8063 37.5511ZM23.1876 35.5184H18.8124V31.3702H23.1876V35.5184ZM23.1876 28.2595H18.8124V14.778H23.1876V28.2595Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0)" />
            </svg>
          </GridColumn>
          <GridColumn className={`${css.titleContainer}`} width={12}>
            <p className={css.title}>{formatText(title)}</p>
          </GridColumn>
        </GridRow>
        <GridRow className={`${css.noPaddingTop}`} columns={2} verticalAlign={'top'}>
          <GridColumn className={`${css.order}`} width={16}>
            {formatText(text)}
            {!!errorCode && (
              <div className={css.errorCodeContainer}>
                Felkod: <span className={css.errorCode}>{errorCode}</span>
              </div>
            )}
          </GridColumn>
        </GridRow>
      </Grid>
    </Card>
  );
};

export default React.memo(WarningCard);
